import { render, staticRenderFns } from "./test_entry.vue?vue&type=template&id=54d95526&scoped=true"
import script from "./test_entry.vue?vue&type=script&lang=js"
export * from "./test_entry.vue?vue&type=script&lang=js"
import style0 from "./test_entry.vue?vue&type=style&index=0&id=54d95526&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d95526",
  null
  
)

export default component.exports